import { create } from "zustand";

const useDashboardStore = create((set) => ({
  isIconChoosed: false,
  isUS30Choosed: false,
  isCommunityChoosed: false,
  communityIndex: null,
  communities: [],
  traders: [],
  users: [],
  channels: [],
  allChannels: [],
  selectedChannel: null,
  selectedZoomSession: null,
  editCommunityId: null,
  editChannelId: null,
  editLiveSession: null,
  editHomeSectionId: null,
  userJoinedChannels: [],

  setIsIconChoosed: () =>
    set({
      isIconChoosed: true,
      isUS30Choosed: false,
      isCommunityChoosed: false,
      communityIndex: null,
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    }),
  setIsUS30Choosed: () => {
    set({
      isIconChoosed: false,
      isUS30Choosed: true,
      isCommunityChoosed: false,
      communityIndex: null,
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "US30");
  },
  setCommunityIndex: (index) => {
    set({
      isIconChoosed: false,
      isUS30Choosed: false,
      isCommunityChoosed: true,
      communityIndex: index,
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("communityIndex", String(index));
  },
  setCommunities: (communities) => set({ communities }),
  setChannels: (channels) => set({ channels }),
  setAllChannels: (channels) => set({ allChannels: channels }),
  setTraders: (traders) => set({ traders }),
  setUsers: (users) => set({ users }),
  setSelectedChannel: (channel) => {
    set({ selectedChannel: channel });
    localStorage.setItem("selectedChannel", JSON.stringify(channel));
  },
  setSelectedZoomSession: (zoom) => set({ selectedZoomSession: zoom }),
  setEditCommunityId: (id) => set({ editCommunityId: id }),
  setEditChannelId: (id) => set({ editChannelId: id }),
  setEditLiveSession: (session) => set({ editLiveSession: session }),
  setEditHomeSectionId: (id) => set({ editHomeSectionId: id }),
  setUserJoinedChannels: (channels) => set({ userJoinedChannels: channels }),

  //For Showing the Right Cards:
  isCreateCommunityScreen: false,
  isAllCommunityScreen: false,
  isCreateChannelScreen: false,
  isAllChannelScreen: false,
  isChatScreen: false,
  isCreateLiveSessionScreen: false,
  isAllLiveSessionScreen: false,
  isAllHomeSectionScreen: false,
  isCreateHomeSectionScreen: false,
  isZoomMeetingScreen: false,
  isUpcomingLiveSessionScreen: false,
  isUsersScreen: false,
  isMyProfileScreen: false,
  isMyMembershipScreen: false,

  setIsCreateCommunityScreen: () => {
    set({
      isCreateCommunityScreen: true,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateCommunityScreen");
  },
  setIsAllCommunityScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: true,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "AllCommunityScreen");
  },
  setIsCreateChannelScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: true,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateChannelScreen");
  },
  setIsAllChannelScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: true,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "AllChannelScreen");
  },
  setIsChatScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: true,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "ChatScreen");
  },
  setIsCreateLiveSessionScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: true,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateLiveSessionScreen");
  },
  setIsAllLiveSessionScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: true,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "AllLiveSessionScreen");
  },
  // Home Section screen setters
  setIsAllHomeSectionScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: true,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "AllHomeSectionScreen");
  },
  setIsCreateHomeSectionScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: true,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "CreateHomeSectionScreen");
  },
  setIsZoomMeetingScreen: () =>
    set({
      isUS30Choosed: false,
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: true,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    }),
  setIsUpcomingLiveSessionScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: true,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "UpcomingLiveSessionScreen");
  },
  setIsUsersScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: true,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "UsersScreen");
  },
  setIsMyProfileScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: true,
      isMyMembershipScreen: false,
    });
    localStorage.setItem("lastScreen", "MyProfile");
  },
  setIsMyMembershipScreen: () => {
    set({
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: true,
    });
    localStorage.setItem("lastScreen", "MySubscription");
  },

  resetDashboard: () =>
    set({
      isIconChoosed: false,
      isUS30Choosed: false,
      isCommunityChoosed: false,
      communityIndex: null,
      communities: [],
      traders: [],
      users: [],
      channels: [],
      allChannels: [],
      selectedChannel: null,
      selectedZoomSession: null,
      editCommunityId: null,
      editChannelId: null,
      editLiveSession: null,
      editHomeSectionId: null,
      userJoinedChannels: [],
      isCreateCommunityScreen: false,
      isAllCommunityScreen: false,
      isCreateChannelScreen: false,
      isAllChannelScreen: false,
      isChatScreen: false,
      isCreateLiveSessionScreen: false,
      isAllLiveSessionScreen: false,
      isAllHomeSectionScreen: false,
      isCreateHomeSectionScreen: false,
      isZoomMeetingScreen: false,
      isUpcomingLiveSessionScreen: false,
      isUsersScreen: false,
      isMyProfileScreen: false,
      isMyMembershipScreen: false,
    }),
}));

export default useDashboardStore;
